// Roles operativos con paridad total (rondas, novedades, visitas, chat,
// elementos de trabajo, SOS). Agregar un rol nuevo acá alcanza para que
// herede todos los permisos/vistas que ya tiene "vigilador".
export const OPERATIONAL_ROLES = ["vigilador", "operario_limpieza", "custodio"];
// "cliente"/"cliente_admin" NO son operativos: son los usuarios del cliente
// final (el consorcio/empresa a la que se le presta el servicio), acotados
// a sus objetivos vía `client_access`. "cliente_admin" es la administración
// del consorcio: mismo acceso de solo lectura + ve/aprueba/cancela TODAS
// las reservas del SUM, el total de horas del cronograma y Visitas e
// Ingresos (restringido para el rol base "cliente").
export const CLIENTE_ROLES = ["cliente", "cliente_admin"];
// "inquilino": el vecino/inquilino individual de un edificio o barrio,
// distinto del cliente (consorcio) y del cliente_admin (administración).
// Acceso muy acotado: reservas del SUM, autorizaciones de su domicilio,
// personal autorizado propio y botón SOS — nunca cronograma/equipos/rondas.
export const TENANT_ROLES = ["inquilino"];
export const USER_ROLE_KEYS = ["admin", "supervisor", ...OPERATIONAL_ROLES, ...CLIENTE_ROLES, ...TENANT_ROLES];

export const ROLE_LABELS = {
  admin: "Administrador",
  supervisor: "Supervisor",
  vigilador: "Vigilador",
  operario_limpieza: "Operario de limpieza",
  custodio: "Custodio",
  cliente: "Cliente",
  cliente_admin: "Cliente (administración)",
  inquilino: "Inquilino",
};

export const ROLE_BADGE = {
  admin: "red",
  supervisor: "blue",
  vigilador: "gray",
  operario_limpieza: "green",
  custodio: "amber",
  cliente: "blue",
  cliente_admin: "blue",
  inquilino: "amber",
};

export const isOperationalRole = (role) => OPERATIONAL_ROLES.includes(role);
export const isClienteRole = (role) => CLIENTE_ROLES.includes(role);
export const isTenantRole = (role) => TENANT_ROLES.includes(role);
export const roleLabel = (role) => ROLE_LABELS[role] || role || "";
